import { useContext } from "react";
import { useQuery } from "react-query";
import { AxiosContext } from "services/axios.context";
import { AuthenticationContext } from "services/authentication.context";

export const useTour = (id, initialData = {}) => {
  const { isAuthenticated } = useContext(AuthenticationContext);
  const { client } = useContext(AxiosContext);
  const axios = isAuthenticated ? client : client;
  return useQuery(
    `tour-${id}`,
    () => {
      console.debug(`💰 Tour ${id}`);
      return axios.get(`tours/${id}/`).then((resp) => resp.data);
    },
    {
      enabled: !!id,
      placeholderData: initialData,
      staleTime: 5000,
    }
  );
};
